/**
 * Family and Primary tags (CWS-1582 §8): the one rule every screen uses to decide which family
 * tags a membership or an order carries, so the lane pop-ups, Orders and the Membership tab
 * cannot drift apart.
 */

/** The three fields the API adds to a membership option, an order and a membership card. */
export interface FamilyTagSource {
  family_group_id?: string | null;
  is_family?: boolean | null;
  is_primary?: boolean | null;
}

export interface FamilyTags {
  /** Part of a family plan. */
  isFamily: boolean;
  /** The primary of a family plan; never true without `isFamily`. */
  isPrimary: boolean;
}

/** Label of the family tag. */
export const FAMILY_TAG_LABEL = 'Family plan';
/** Label of the primary tag. */
export const FAMILY_PRIMARY_TAG_LABEL = 'Primary';

const NO_TAGS: FamilyTags = { isFamily: false, isPrimary: false };

/** Only a real `true` tags a row, so a missing field or a stray string never shows a pill. */
export function familyTagsOf(source: FamilyTagSource | null | undefined): FamilyTags {
  if (source?.is_family !== true) {
    return NO_TAGS;
  }
  return { isFamily: true, isPrimary: source.is_primary === true };
}
